
















































import { Cadastros, DashboardService } from "@/services/dashboard.service";
import {
  dateDay,
  dateFullNameMonth,
  dateMonth,
  dateYear,
  dateYearMonth,
} from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import "@/shared/utils/promises";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { Component, Mixins, PropSync, Watch } from "vue-property-decorator";
import AssinaturasExpiradasTable from "./components/diario/AssinaturasExpiradasTable.vue";
import AssinaturasHojeCard from "./components/diario/AssinaturasHojeCard.vue";
import DeltaAssinantesDiaCard from "./components/diario/DeltaAssinantesDiaCard.vue";
import GratisExpiradosCard from "./components/diario/GratisExpiradosCard.vue";
import GraficoDonutCadastrosDiarios from "./components/diario/GraficoDonutCadastrosDiarios.vue";
import PlanoExpiradoCard from "./components/diario/PlanoExpiradoCard.vue";
import PlanosContratadosTable from "./components/diario/PlanosContratadosTable.vue";

@Component({
  components: {
    GraficoDonutCadastrosDiarios,
    AssinaturasHojeCard,
    DeltaAssinantesDiaCard,
    PlanoExpiradoCard,
    GratisExpiradosCard,
    PlanosContratadosTable,
    AssinaturasExpiradasTable,
  },
  filters: { dateFullNameMonth, dateYear, dateDay, dateYearMonth, dateMonth },
})
export default class DashboardTvDiario extends Mixins(GlobalMixin) {
  loading = false;
  show = false;
  cadastros: Cadastros[] | null = null;

  @PropSync("date") dateSync!: string | null;

  mounted() {
    this.show = true;
    if (!this.dateSync) {
      this.dateSync = dayjs().format("YYYY-MM-DDT00:00:00");
    } else {
      const newDate = dayjs(this.dateSync).format("YYYY-MM-DDT00:00:00");
      const call = newDate == this.dateSync;

      this.dateSync = newDate;

      if (call) this.onChangeDate();
    }
    dayjs.locale("pt-br");
  }

  @Watch("dateSync")
  onChangeDate() {
    this.loading = true;
    if (this.dateSync) {
      const data = dateYearMonth(this.dateSync);
      DashboardService.Cadastros(data)
        .then((data) => {
          this.cadastros = data;
        })
        .finally(() => (this.loading = false));
    }
  }
}
